import { defineStore } from 'pinia'
import xor from 'lodash/xor'

const STORE_NAME = 'control-panel'

// Note that this storage is set up as localStorage
export const useControlPanelStore = defineStore(STORE_NAME, {
  state: () => ({
    enabled: [] as string[],
  }),

  getters: {
    isEnabled: (state) => {
      return (name = STORE_NAME) => state.enabled.includes(name)
    },
  },

  actions: {
    reset() {
      this.enabled = []
    },
    toggle(name = STORE_NAME) {
      this.enabled = xor(this.enabled, [name])
    },
    enable(name = STORE_NAME) {
      if (!this.enabled.includes(name)) {
        this.enabled = xor(this.enabled, [name])
      }
    },
  },

  persist: {
    pick: ['enabled'],
    storage: piniaPluginPersistedstate.localStorage(),
    key: `db-${STORE_NAME}`,
  },
})
